export function CreateModelRunFromModeler(modeler) {
  let inputVals = [];

  for (let item of modeler.inputGroups || []) {
    for (let val of item.inputItems) {
      inputVals.push({ itemName: val.name, itemValue: val.defaultValue });
    }
  }

  return {
    modelerId: modeler.id,
    runName: "New Run",
    runStatus: "CREATED",
    inputValues: [...inputVals],
  };
}

export const ASSET_TYPES = {
  Pictures: "PICTURES",
  Documents: "DOCUMENTS",
  Archives: "ARCHIVES",
  Videos: "VIDEOS",
};
